<template>
  <div class="notFoundPage">
    <div class="wrap">
      <img class="mainImage" src="../assets/images/img404.png" alt="">
      <div class="content">
        <p>SORRY，您正在访问的页面丢失了～</p>
        <el-button type="primary" @click="refreshBtn">刷新</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    refreshBtn () {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
.notFoundPage{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #FFFFFF;
  >.wrap{
    width: 666px;
    position: relative;
    top: 50%;
    margin: 0 auto;
    color: #424C57;
    transform: translateY(-56%);
    >img{
      width: 100%;
    }
    >.content{
      width: 100%;
      position: absolute;
      bottom: 50px;
      text-align: center;
      >p{
        font-size: 20px;
      }
      >.el-button{
        margin-top: 48px;
      }
    }
  }
  //>.wrap{
  //  width: 528px;
  //  margin: 0 auto;
  //  position: relative;
  //  top: 50%;
  //  transform: translateY(-50%);
  //  text-align: center;
  //  >.aircraft{
  //    width: 774px;
  //    position: absolute;
  //    top: -186px;
  //    left: -450px;
  //  }
  //  >.mainImage{
  //    width: 100%;
  //  }
  //  >p{
  //    font-size: 24px;
  //    color: #ffffff;
  //    font-weight: bold;
  //    line-height: 30px;
  //    margin: 66px 0 56px;
  //  }
  //  >.btn{
  //    width: 240px;
  //    line-height: 56px;
  //    margin: 0 auto;
  //    outline: none;
  //    border: 1px solid #ffffff;
  //    color: #ffffff;
  //    background: rgba(255,255,255,0);
  //    cursor: pointer;
  //  }
  //}
}
</style>
